import { render, staticRenderFns } from "./DonutChart81.vue?vue&type=template&id=b21e1088&scoped=true&"
import script from "./DonutChart81.vue?vue&type=script&lang=js&"
export * from "./DonutChart81.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21e1088",
  null
  
)

export default component.exports